<template>
  <v-card
    class="historical-competition-card"
    elevation="0"
    @click="$emit('click', competition)"
  >
    <div class="card-content">
      <!-- Competition Name -->
      <h2 class="text-h2 font-weight-bold competition-title">{{ competition.name }}</h2>

      <!-- End Date Container -->
      <div class="end-date-container">
        <v-icon size="14" class="font-weight-bold">fa-regular fa-clock</v-icon>
        <span class="text-body-2 font-weight-bold">Ended {{ formattedEndDate }}</span>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'HistoricalCompetitionCard',
  props: {
    competition: {
      type: Object,
      required: true
    }
  },
  computed: {
    formattedEndDate() {
      const date = new Date(this.competition.endDate)
      return new Intl.DateTimeFormat('en-US', {
        month: 'numeric',
        day: 'numeric',
        year: 'numeric'
      }).format(date).replace(/\//g, '/')
    }
  }
}
</script>

<style lang="scss" scoped>
.historical-competition-card {
  cursor: pointer;
  transition: all 0.3s ease;
  border: none !important;
  border-radius: 12px;
  background: white !important;
  box-shadow: 0px 5px 10px 0px rgba(44, 44, 44, 0.1) !important;
  width: 100%;
  min-height: 120px;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0px 8px 16px 0px rgba(44, 44, 44, 0.15) !important;
  }

  .card-content {
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    min-height: 120px;

    .competition-title {
      margin-bottom: 16px;
      color: #000000 !important;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      line-height: 1.5 !important;
      height: auto;
      min-height: 0;
      padding-bottom: 2px;
    }

    .end-date-container {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      background: #EEEEEE;
      color: black;
      border-radius: 12px;
      padding: 8px 16px;
      width: fit-content;
      margin-top: auto; // Push to bottom
      .v-icon{
        color: black;
      }
    }
  }
}
</style>